<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click.stop="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>编辑权限 已选 {{selected.length}} 项</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click.stop="save" :loading="loading" :disabled="loading">
          <span class="text-h6">保存</span>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" class="text-body-1 black--text">
            角色名称：{{roleData.name}}（{{roleData.code}}）
          </v-col>
          <v-col cols="12">
            <v-data-table
              v-model="selected"
              show-select
              item-key="key"
              :headers="headers"
              :items="apiList"
              :items-per-page="100"
              :footer-props="{itemsPerPageOptions: [50,100,500]}"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { buildAxios } from '@/plugins/axios'
import { handleResponse } from '@/plugins/errorHandler'

export default {
  name: 'PermissionDialog',
  props: {
    status: Boolean,
    roleData: Object
  },
  data () {
    return {
      loading: false,
      selected: [],
      headers: [
        {
          text: '控制器',
          value: 'controller'
        },
        {
          text: '方法',
          value: 'funcName',
          sortable: false
        },
        {
          text: '请求方式',
          value: 'method'
        },
        {
          text: '地址',
          value: 'pattern',
          sortable: false
        }
      ]
    }
  },
  computed: {
    permApi () {
      const res = this.$store.state.permApi
      return res || {}
    },
    apiList () {
      if (!this.$store.state.permApi) {
        return []
      }
      const list = Object.values(this.$store.state.permApi)
      list.sort(compareApi)
      return list
    }
  },
  created () {
    this.selectApi(this.roleData)
  },
  methods: {
    selectApi (arg) {
      if (arg.api) {
        this.selected = arg.api.map(a => this.permApi[a]).filter(a => !!a)
      } else {
        this.selected = []
      }
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.loading = true

      const apiSet = this.selected.map(a => a.key)
      const payload = {
        roleId: this.roleData.id,
        apiSet: apiSet
      }
      const request = buildAxios()
      request.post('role/modifyPerms', payload)
        .then(res => {
          this.$emit('save', res.data.data)
          this.loading = false
        })
        .catch(reason => {
          this.$emit('alert', {
            msg: handleResponse(reason.response),
            type: 'error'
          })
          this.loading = false
        })
    }
  },
  watch: {
    status () {
      this.selectApi(this.roleData)
    }
  }
}

const compareApi = (a, b) => {
  if (a.controller > b.controller) {
    return 1
  }
  if (a.controller < b.controller) {
    return -1
  }
  if (a.funcName > b.funcName) {
    return 1
  }
  if (a.funcName < b.funcName) {
    return -1
  }
  return 0
}
</script>
